import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
    selector: 'app-search-filter',
    templateUrl: './search-filter.component.html',
    styleUrls: ['./search-filter.component.scss']
})
export class SearchFilterComponent {

    @Output() onSearch: EventEmitter<string> = new EventEmitter<string>();

    @Input() text: string;

    @Input() autocomplete = false;
    @Input() isDesktop = false;

    isInputVisible = false;

    onShowSearch() {

        this.isInputVisible = !this.isInputVisible;
    }

    onEnterEvent() {

        this.onSearch.emit(this.text);
    }

    onChangeEvent() {

        if (this.autocomplete) {
            this.onSearch.emit(this.text);
        }
    }
}
